import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faArrowLeft, faBookmark } from '@fortawesome/free-solid-svg-icons';

const EmptyFlashcardsState = ({ title, onBack, theme }) => {
  const styles = {
    container: {
      minHeight: '100vh',
      background: theme?.background?.main,
      padding: '2rem',
    },
    header: {
      marginBottom: '2rem',
    },
    backButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.75rem',
      background: theme?.backgrounds?.secondary,
      border: `1px solid ${theme?.borders?.primary}`,
      color: theme?.text?.primary,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '0.875rem',
      fontWeight: '500',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
    },
    card: {
      background: theme?.background?.card,
      borderRadius: '1.5rem',
      padding: '3rem',
      border: `1px solid ${theme?.borders?.primary}`,
      boxShadow: theme?.shadows?.base,
      textAlign: 'center',
      maxWidth: '400px',
      width: '100%',
    },
    iconWrapper: {
      width: '5rem',
      height: '5rem',
      borderRadius: '1rem',
      background: `linear-gradient(135deg, ${theme?.primary?.amber?.[100] || '#fef3c7'}20, ${theme?.primary?.amber?.[200] || '#fde68a'}30)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1.5rem',
      fontSize: '2.5rem',
      color: theme?.primary?.amber?.[500] || '#f59e0b',
      position: 'relative',
    },
    bookmarkIcon: {
      position: 'absolute',
      bottom: '-0.5rem',
      right: '-0.5rem',
      fontSize: '1.5rem',
      background: theme?.background?.card,
      padding: '0.5rem',
      borderRadius: '50%',
      border: `2px solid ${theme?.borders?.primary}`,
      color: theme?.text?.tertiary,
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: theme?.text?.primary,
      marginBottom: '0.75rem',
    },
    message: {
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
      lineHeight: 1.6,
    },
  };

  const isBookmarkView = title === "Bookmark";

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <motion.button
          style={styles.backButton}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onBack}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Go Back
        </motion.button>
      </div>

      <div style={styles.content}>
        <motion.div
          style={styles.card}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            style={styles.iconWrapper}
            animate={{ 
              rotate: [0, -10, 10, 0],
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              repeatDelay: 1,
            }}
          >
            <FontAwesomeIcon icon={faLayerGroup} />
            {isBookmarkView && (
              <FontAwesomeIcon icon={faBookmark} style={styles.bookmarkIcon} />
            )}
          </motion.div>
          
          <h2 style={styles.title}>
            {isBookmarkView ? 'No Bookmarked Flashcards' : 'No Flashcards Available'}
          </h2>
          
          <p style={styles.message}>
            {isBookmarkView 
              ? "You haven't bookmarked any flashcards yet. Bookmark cards while studying to review them later."
              : "There are no flashcards in this set. Please go back and select a different set."}
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default EmptyFlashcardsState;